import { toast } from 'sonner';

// One completion toast for every way transactions come in (bank update, statement upload):
// "<title>" + "N added to your books, M need review." + one-tap jump to Review Needed.
export const notifyImportComplete = ({ title, added = 0, reviewNeeded = 0, extra = '', navigate }) => {
  const body = `${Number(added || 0).toLocaleString()} added to your books, ${Number(reviewNeeded || 0).toLocaleString()} need review.${extra ? ` ${extra}` : ''}`;
  toast.success(title, {
    description: body,
    duration: 10000,
    ...(reviewNeeded > 0 && navigate
      ? { action: { label: 'Review Needed', onClick: () => navigate('/bank-feeds?filter=pending') } }
      : {}),
  });
};
